import { useCallback } from "react";
import { useTourContext } from "../contexts/TourContext";

// Only the tour registered by the current route can be replayed, which is what
// keeps this usable from shell UI that has no idea which page it is sitting on
const useTourReplay = ({ onReplay } = {}) => {
   const { activeTourId, requestTour } = useTourContext();

   const replayTour = useCallback(() => {
      if (!activeTourId) {
         return;
      }

      requestTour(activeTourId);
      onReplay?.();
   }, [activeTourId, requestTour, onReplay]);

   return { canReplayTour: Boolean(activeTourId), replayTour };
};

export default useTourReplay;
